import indexedObject from './indexed-object.js';
import requireObjectCoercible$1 from './require-object-coercible.js';

var IndexedObject = indexedObject;
var requireObjectCoercible = requireObjectCoercible$1;

var toIndexedObject = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};

export { toIndexedObject as default };
